export default {
  label: {
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    password: 'Password',
    phone: 'Phone',
    currentPassword: 'New Password',
    record: 'Register',
    oldPassword:'Old Password',
    newPassword:'New Password'
  },
  account: {
    title: 'My Account',
    salesHistoricTitle: 'Order history',
    ordersPlacedIn: 'Orders placed in',
    emptyOrderTableText: 'No previous orders',
    salesHistoricDescription: 'Here you have access to the history of all the purchases you have made at Boires.',
    consultSalesHistoric: 'View my history',
    profileTitle: 'Customer profile',
    profileDescription: 'Here you can edit your personal information. Keep it up to date to ensure you receive your orders in the right place.',
    consultMyProfile: 'View my profile',
    subscriptionTitle: 'Subscriptions',
    subscriptionDescription: 'Here you can change your preferences and subscribe to our newsletters.',
    consultsubscription: 'Check my subscriptions',
    logout: 'Log out',
    personnalInfosTitle: 'Personal information',
    editBtn: 'Edit',
    search: 'Look for',
    password: 'Password',
    salesHistory: {
      orderHeader: 'Ordered',
      salesOrderNumberHeader: 'Number',
      salesOrderTotalHeader: 'Total',
      invoice: 'Facture',
      price: 'Prix',
      agencyFee: 'Agency costs : ',
      saqValue: 'SAQ value : ',
      qty: '{x} crate (x{n}) | {x} crates (x{n}) ',
      noData: 'No order history'
    },
    shippingAndBillingAddresses: 'Delivery address and billing',
    branchPickup: 'Branch pickup',
    chercher: 'Look for',
  },
  login: {
    registration: {
      intro: 'Create your account to enter your information just once! You will also be able to access your order and delivery history.',
    },
    title: 'Login',
    label: {
      forgotPassword: 'Forgot password',
      login: 'Login',
    },
    account: 'Account',
    rememberMe: 'Remember Me',
  },
  registration: {
    intro: 'Create your account to enter your information just once! You will also be able to access your order and delivery history.',
    title: 'Registration',
    label: {
      consent: 'I would like to receive news from Boires.ca',
      register: 'Register',
    },
    confirmationSuccess: 'Registration completed',
    confirmationText: 'Thank you for your registration. <br>You will receive a confirmation email shortly with instructions to activate your account!',
  },
  suggestions: 'Our suggestions',
  forgotPassword: {
    title: 'PASSWORD CHANGE',
    placeHolder: 'New Password',
    button: 'Edit',
    text: '2021 Boires Inc. all rights reserved - BOIRES is a registered trademark of Boires Inc.',
  },
  forgotPasswordModal: {
    title1: 'FORGOT YOUR PASSWORD',
    title2: 'Temporary Password Sent',
    placeHolder: 'Email',
    button: 'Reset password',
    cancel: 'Cancel',
    text: 'We will send you an email to reset your password.',
    success: 'Temporary Password Sent',
    successBtn: 'Close',
    successTextPart1: 'An email has been sent to',
    successTextPart2: 'with a temporary password. Please check your inbox and use the temporary password to access your account. Do\'t forget to change your password after logging in for security reasons. Thank you!',
  },
  deliveryAddress: {
    aptSuite: 'Apartment / suite',
    rue: 'Street',
    civicNumber: 'Civic number',
    province: 'Province',
    codePostal: 'Postal code',
    ville: 'City',
    copyAddress: 'Use the same address for delivery',
    deliveryAddress: 'Delivery address',
    billingAddress: 'Billing address',
    formRequiredMsg: {
      rue: 'Your street is required',
      ville: 'Your city is required',
      province: 'Your province is required',
      codePostal: 'Your Postal Code is mandatory',
      rue2: 'Your street is required',
      firstName: 'Your first name is required',
      lastName: 'Your name is required',
      email: 'Your email is required',
      phone: 'Your phone is required',
    }
  },
  branchPickup: {
    title: 'FIND A BRANCH',
    subTitle: 'Select a city to see available branches.',
    cancel: 'Cancel',
    submit: 'Select'
  },
  resetPassword: {
    title: 'Create a new Password',
    confirpwd: 'Confirm Password'
  }
};
